import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./HF.css";
import ABS from "../../assets/logo.png";
import { LuLogOut } from "react-icons/lu";
import { useClientList } from "../../hooks/useClientList";

const Header = ({ isLoggedIn, setIsLoggedIn }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));
  const { clientlist } = useClientList(userDetails);

  const handleLogout = () => {
    sessionStorage.setItem("manualLogout", "true"); // mark it as a user-initiated logout
    localStorage.removeItem("userdetails");
    setIsLoggedIn(false);
    navigate("/");
  };

  //   const handleLogout = () => {
  //   localStorage.removeItem("userdetails");
  //   setIsLoggedIn(false);
  //   navigate("/");
  // };

  // const handleLogout = () => {
  //   sessionStorage.setItem("manualLogout", "true");
  //   localStorage.removeItem("userdetails");
  //   setIsLoggedIn(false);

  //   // Use a short delay to allow ProtectedRoute to read manualLogout before redirect triggers
  //   setTimeout(() => {
  //     navigate("/");
  //   }, 50); // 50ms is enough
  // };

  useEffect(() => {
    if (location.pathname === "/") {
      localStorage.removeItem("userdetails");
      setIsLoggedIn(false);
    } else {
      const userDetails = JSON.parse(localStorage.getItem("userdetails"));
      if (userDetails?.username) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    }
  }, [location.pathname]);

  const logoFile = clientlist?.[0]?.logo;
  const src = ["bh", "cmanager", "user"].includes(userDetails?.role)
    ? `${process.env.REACT_APP_BASEURL}/apis/uploads/logo/${logoFile}`
    : ABS;

  return (
    <header className="header">
      <div className="container">
        <img className="logo" src={src} alt="logo" />
        <strong className="app-title">IT Support Portal</strong>
        <nav>
          <ul className="nav-list">
            <li>
              {isLoggedIn ? (
                <button onClick={handleLogout} className="btton">
                  Logout{" "}
                  <div>
                    <LuLogOut />
                  </div>
                </button>
              ) : null}
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
